import React from 'react';
import { Button, DatePicker, Form, Select } from 'antd';
import { openNotification } from '../../../utils';
import dayjs from 'dayjs';
import { APP_LOCAL_DATE_FORMAT } from 'config/constants';
import { apiFetch } from 'services/apiClient';
import { createInspectionAppointment, updateInspectionAppointment, getInspectionAppointment } from '../services/inspection-appointmentService';
import { CreateInspectionAppointmentDto } from '../types/InspectionAppointment';

export default function InspectionAppointmentForm({ id, onSuccess, referenceId }: { id?: number; onSuccess: () => void; referenceId?: number }) {
  const [form] = Form.useForm<CreateInspectionAppointmentDto>();
  
  const [companyOptions, setCompanyOptions] = React.useState<any[]>([]);
  const [addresOptions, setAddresOptions] = React.useState<any[]>([]);
  const [authorizedPersonOptions, setAuthorizedPersonOptions] = React.useState<any[]>([]);
  const [proposalOptions, setProposalOptions] = React.useState<any[]>([]);
  const company = Form.useWatch('company', form);
  React.useEffect(() => {
    if (id) {
      getInspectionAppointment(id).then(d => { const data: any = { ...d }; if (data.startDate) data.startDate = dayjs(data.startDate); if (data.endDate) data.endDate = dayjs(data.endDate); if (data.company) data.company = typeof data.company === 'object' ? data.company.id : data.company; if (data.address) data.address = typeof data.address === 'object' ? data.address.id : data.address; if (data.authorizedPerson) data.authorizedPerson = typeof data.authorizedPerson === 'object' ? data.authorizedPerson.id : data.authorizedPerson; if (data.proposal) data.proposal = typeof data.proposal === 'object' ? data.proposal.id : data.proposal; form.setFieldsValue(data); });
    } else {
      form.resetFields();
    }
    apiFetch('/companies').then(setCompanyOptions);
    apiFetch('/proposals').then(setProposalOptions);
  }, [id, form]);
  React.useEffect(() => { if (company) { apiFetch(`/companies/${company}/addresses`).then(setAddresOptions); } else { setAddresOptions([]); } }, [company]);
  React.useEffect(() => { if (company) { apiFetch(`/authorized-persons?companyId=${company}`).then(setAuthorizedPersonOptions); } else { setAuthorizedPersonOptions([]); } }, [company]);
  const onFinish = async (values: CreateInspectionAppointmentDto) => {
    const data: any = { ...values }; if (data.startDate) data.startDate = data.startDate.format('YYYY-MM-DD'); if (data.endDate) data.endDate = data.endDate.format('YYYY-MM-DD');
    try {
      if (id) {
        await updateInspectionAppointment(id, data);
        openNotification('success', 'Başarılı', 'Denetim Randevusu Güncellendi');
      } else {
        await createInspectionAppointment(data);
        openNotification('success', 'Başarılı', 'Denetim Randevusu Eklendi');
      }
      onSuccess();
    } catch (e) {
      openNotification('error', 'Hata', 'Denetim Randevusu işlemi başarısız');
    }
  };
  return (
    <>
      
      <Form form={form} onFinish={onFinish} layout='vertical'>
      <Form.Item name='company' label='Firma' rules={[{ required: true }]}>
        <Select showSearch filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))} placeholder='Seçiniz' style={{width:'100%'}}>
          {companyOptions.map(o => <Select.Option key={o.id} value={o.id}>{o?.name ?? o.id}</Select.Option>)}
        </Select>
      </Form.Item>
      <Form.Item name='address' label='Adres' rules={[{ required: true }]}>
        <Select showSearch filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))} placeholder='Seçiniz' style={{width:'100%'}}>
          {addresOptions.map(o => <Select.Option key={o.id} value={o.id}>{o.name ?? o.id}</Select.Option>)}
        </Select>
      </Form.Item>
      <Form.Item name='authorizedPerson' label='Yetkili Kişi'>
        <Select showSearch filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))} placeholder='Seçiniz' style={{width:'100%'}}>
          {authorizedPersonOptions.map(o => <Select.Option key={o.id} value={o.id}>{o.name ?? o.id}</Select.Option>)}
        </Select>
      </Form.Item>
      <Form.Item name='proposal' label='Teklif'>
        <Select showSearch filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))} placeholder='Seçiniz' style={{width:'100%'}}>
          {proposalOptions.map(o => <Select.Option key={o.id} value={o.id}>{o.name ?? o.id}</Select.Option>)}
        </Select>
      </Form.Item>
      <Form.Item name='startDate' label='Başlangıç Tarihi' rules={[{ required: true }]}>
        <DatePicker format={APP_LOCAL_DATE_FORMAT} placeholder='Seçiniz' style={{width:'100%'}} />
      </Form.Item>
      <Form.Item name='endDate' label='Bitiş Tarihi' rules={[{ required: true }]}>
        <DatePicker format={APP_LOCAL_DATE_FORMAT} placeholder='Seçiniz' style={{width:'100%'}} />
      </Form.Item>
      <Button htmlType='submit' type='primary' block>Kaydet</Button>
    </Form>
    </>
  );
}
